export default {
  type: 'Polygon',
  coordinates: [
    [
      [
        55.2417725739772,
        36.93620199707029,
      ],
      [
        55.20330612326975,
        36.965041108398395,
      ],
      [
        55.14160342001831,
        37.04469198730467,
      ],
      [
        55.11091289606706,
        37.05430502441403,
      ],
      [
        55.0979213105739,
        37.11541647460934,
      ],
      [
        55.063256340277135,
        37.11747641113277,
      ],
      [
        55.05695037615813,
        37.08451742675778,
      ],
      [
        55.0005465005693,
        37.15524191406247,
      ],
      [
        54.99146710376897,
        37.13395590332027,
      ],
      [
        54.923899038106256,
        37.19232077148434,
      ],
      [
        54.86730709223588,
        37.16691488769527,
      ],
      [
        54.82927047393347,
        37.293944306640604,
      ],
      [
        54.850670503804714,
        37.30287069824215,
      ],
      [
        54.8340270211742,
        37.35574240234373,
      ],
      [
        54.85265141153304,
        37.37016195800777,
      ],
      [
        54.83917931212119,
        37.37702841308591,
      ],
      [
        54.83878300550205,
        37.455306000976535,
      ],
      [
        54.79318166701964,
        37.497191376953104,
      ],
      [
        54.78088028257289,
        37.543883271484354,
      ],
      [
        54.73839178078464,
        37.54800314453122,
      ],
      [
        54.7443508128609,
        37.62628073242185,
      ],
      [
        54.7165344616895,
        37.68464560058592,
      ],
      [
        54.7443508128609,
        37.76292318847654,
      ],
      [
        54.81579053285241,
        37.779402680664035,
      ],
      [
        54.832441567974875,
        37.74781698730466,
      ],
      [
        54.850670503804714,
        37.935957856445285,
      ],
      [
        54.82570269407051,
        37.98882956054684,
      ],
      [
        54.78127716009973,
        37.95449728515622,
      ],
      [
        54.782864631089566,
        38.01629538085935,
      ],
      [
        54.76460493568845,
        38.038954682617145,
      ],
      [
        54.71971444404825,
        38.02796835449217,
      ],
      [
        54.71772698443611,
        38.11723227050777,
      ],
      [
        54.68750554664531,
        38.13783163574216,
      ],
      [
        54.69705160204132,
        38.21061605957027,
      ],
      [
        54.67835512671151,
        38.21748251464841,
      ],
      [
        54.6648246234166,
        38.25662130859371,
      ],
      [
        54.677957235365255,
        38.29026693847652,
      ],
      [
        54.652085895115135,
        38.31773275878902,
      ],
      [
        54.638944879249316,
        38.39120382812497,
      ],
      [
        54.64491859728516,
        38.46948141601559,
      ],
      [
        54.593914524056444,
        38.51823324707028,
      ],
      [
        54.571978980787875,
        38.445448823242145,
      ],
      [
        54.536857431794466,
        38.45025534179685,
      ],
      [
        54.545241470504315,
        38.42141623046872,
      ],
      [
        54.52687417706424,
        38.37609762695309,
      ],
      [
        54.46692313016869,
        38.38571066406248,
      ],
      [
        54.44051667937615,
        38.45025534179685,
      ],
      [
        54.40247734856437,
        38.475661225585895,
      ],
      [
        54.39486522623632,
        38.527159638671854,
      ],
      [
        54.295376806810026,
        38.515486665039035,
      ],
      [
        54.281316618019865,
        38.63084311035152,
      ],
      [
        54.25680019156376,
        38.66448874023433,
      ],
      [
        54.27207443992127,
        38.713927216796854,
      ],
      [
        54.34876156236081,
        38.71186728027339,
      ],
      [
        54.39326249335317,
        38.83477682617183,
      ],
      [
        54.371619443109715,
        38.87597555664059,
      ],
      [
        54.39286180030513,
        38.86979574707029,
      ],
      [
        54.40888645630368,
        38.93914694335934,
      ],
      [
        54.43931597958817,
        38.93022055175776,
      ],
      [
        54.45332194385785,
        38.800444550781215,
      ],
      [
        54.47852055437019,
        38.7770986035156,
      ],
      [
        54.524877231797646,
        38.80662436035154,
      ],
      [
        54.53406236768982,
        38.84988302734371,
      ],
      [
        54.55162814815474,
        38.79701132324215,
      ],
      [
        54.56958529472973,
        38.83409018066402,
      ],
      [
        54.6218153338088,
        38.84164328124997,
      ],
      [
        54.63496191070306,
        38.94601339843748,
      ],
      [
        54.60268542000375,
        38.97141928222653,
      ],
      [
        54.64252921587627,
        39.02360434082027,
      ],
      [
        54.633368613551546,
        39.12591452148434,
      ],
      [
        54.66164031745555,
        39.16093344238277,
      ],
      [
        54.638148316891716,
        39.18153280761717,
      ],
      [
        54.637351738858456,
        39.225478120117145,
      ],
      [
        54.662038369412606,
        39.255690522460895,
      ],
      [
        54.6823338247467,
        39.234404511718715,
      ],
      [
        54.7324318680753,
        39.24470419433591,
      ],
      [
        54.72011192422602,
        39.33671469238279,
      ],
      [
        54.747528603243644,
        39.3703603222656,
      ],
      [
        54.757457583930936,
        39.31817526367183,
      ],
      [
        54.83997191363291,
        39.41499228027342,
      ],
      [
        54.866118993093316,
        39.39782614257808,
      ],
      [
        54.90293371633648,
        39.48503012207028,
      ],
      [
        54.93220301838215,
        39.465804047851535,
      ],
      [
        54.98475491890094,
        39.51661581542965,
      ],
      [
        54.989098226086675,
        39.60244650390623,
      ],
      [
        55.0261945104086,
        39.62579245117184,
      ],
      [
        55.00528275800993,
        39.76861471679683,
      ],
      [
        55.0360547425303,
        39.77273458984373,
      ],
      [
        55.00765067610641,
        39.80363363769529,
      ],
      [
        55.11209373895507,
        39.86131186035153,
      ],
      [
        55.137276704132766,
        39.797453828124965,
      ],
      [
        55.11681675997197,
        39.77342123535154,
      ],
      [
        55.11878451987104,
        39.706129975585895,
      ],
      [
        55.186416194882305,
        39.78440756347652,
      ],
      [
        55.215478121172566,
        39.92242331054684,
      ],
      [
        55.200557090246,
        39.99246115234373,
      ],
      [
        55.24216489628458,
        40.03503317382808,
      ],
      [
        55.264912938210855,
        40.15382284667965,
      ],
      [
        55.31663560831132,
        40.20463461425777,
      ],
      [
        55.365161920205836,
        40.19021505859371,
      ],
      [
        55.45071988470247,
        40.13940329101559,
      ],
      [
        55.46281580068381,
        40.19296164062496,
      ],
      [
        55.49869142728489,
        40.1998280957031,
      ],
      [
        55.526745128630786,
        40.166182465820285,
      ],
      [
        55.52713462198856,
        40.04807943847653,
      ],
      [
        55.58279230600408,
        40.047392792968715,
      ],
      [
        55.57890273452825,
        40.0734853222656,
      ],
      [
        55.607676400192425,
        40.09271139648434,
      ],
      [
        55.635652065510435,
        40.0405263378906,
      ],
      [
        55.66671262624034,
        40.04189962890622,
      ],
      [
        55.741931771443866,
        39.90182394531247,
      ],
      [
        55.833626004590734,
        39.88809103515622,
      ],
      [
        55.84289941386622,
        39.73290915039059,
      ],
      [
        55.78722563382679,
        39.70201010253903,
      ],
      [
        55.805019008399135,
        39.62647909667965,
      ],
      [
        55.78722563382679,
        39.52348227050779,
      ],
      [
        55.74541779088504,
        39.52004904296871,
      ],
      [
        55.74580510707245,
        39.482283540039035,
      ],
      [
        55.77987381377439,
        39.435591645507785,
      ],
      [
        55.773681726826034,
        39.325728364257785,
      ],
      [
        55.83246667225689,
        39.29414267089841,
      ],
      [
        55.86452873236926,
        39.3271016552734,
      ],
      [
        55.84135399989344,
        39.2769765332031,
      ],
      [
        55.84599005673495,
        39.10806173828122,
      ],
      [
        55.862598034734134,
        39.092268891601535,
      ],
      [
        55.85796396722464,
        39.05862326171872,
      ],
      [
        55.88035681833011,
        39.07716269042966,
      ],
      [
        55.90852249795728,
        39.02772421386716,
      ],
      [
        55.92433257525621,
        39.045576997070285,
      ],
      [
        55.93242791244655,
        39.00987143066404,
      ],
      [
        55.95092516364624,
        39.04420370605466,
      ],
      [
        55.931271539682264,
        38.95768637207027,
      ],
      [
        55.945145725584815,
        38.884215302734354,
      ],
      [
        55.913921788922124,
        38.83821005371092,
      ],
      [
        55.98019433870445,
        38.73177999999997,
      ],
      [
        55.98173420581194,
        38.59788412597653,
      ],
      [
        55.995205416834224,
        38.57110495117183,
      ],
      [
        56.01521108509984,
        38.61024374511715,
      ],
      [
        56.02290280345356,
        38.592390961914035,
      ],
      [
        56.12697401710965,
        38.51205343749997,
      ],
      [
        56.189434506309524,
        38.501067109374965,
      ],
      [
        56.213930997422125,
        38.52509970214842,
      ],
      [
        56.203598456144995,
        38.46055502441402,
      ],
      [
        56.2670802156858,
        38.396010346679645,
      ],
      [
        56.29267245561477,
        38.43446249511716,
      ],
      [
        56.34075457579398,
        38.41386312988277,
      ],
      [
        56.392203699042405,
        38.44338888671871,
      ],
      [
        56.40134291061354,
        38.382277436523395,
      ],
      [
        56.43293237096681,
        38.41317648437496,
      ],
      [
        56.45537151666161,
        38.398756928710895,
      ],
      [
        56.453470410060184,
        38.35481161621092,
      ],
      [
        56.481597033636874,
        38.34107870605466,
      ],
      [
        56.496032306261405,
        38.297820039062465,
      ],
      [
        56.51653610290578,
        38.33627218749996,
      ],
      [
        56.52640433080737,
        38.26898092773434,
      ],
      [
        56.581391368485185,
        38.36167807128903,
      ],
      [
        56.658994859941025,
        38.31773275878902,
      ],
      [
        56.72058484423123,
        38.31841940429683,
      ],
      [
        56.76020582348779,
        38.30399984863277,
      ],
      [
        56.793756485932064,
        38.24357504394527,
      ],
      [
        56.76246861272571,
        38.24082846191402,
      ],
      [
        56.77302648564375,
        38.15499777343747,
      ],
      [
        56.75077606119232,
        38.062300629882785,
      ],
      [
        56.76812498684454,
        38.050627656249965,
      ],
      [
        56.76774792185672,
        37.99294943359371,
      ],
      [
        56.86528076415601,
        37.98470968749997,
      ],
      [
        56.866032922008955,
        37.952437348632785,
      ],
      [
        56.88821474690019,
        37.9428243115234,
      ],
      [
        56.87919322609612,
        37.88789267089842,
      ],
      [
        56.903997147819716,
        37.865920014648395,
      ],
      [
        56.932538764066095,
        37.751936860351535,
      ],
      [
        56.95017853637093,
        37.758803315429645,
      ],
      [
        56.95918284886771,
        37.69700521972652,
      ],
      [
        56.908880820016336,
        37.53083700683591,
      ],
      [
        56.86753719215207,
        37.57066244628902,
      ],
      [
        56.866032922008955,
        37.543883271484354,
      ],
      [
        56.839322016355034,
        37.550749726562465,
      ],
      [
        56.777927341826945,
        37.475905366210895,
      ],
      [
        56.796770800703285,
        37.4429463818359,
      ],
      [
        56.763977062822235,
        37.3433827832031,
      ],
      [
        56.77566548805248,
        37.27952475097654,
      ],
      [
        56.74700349063156,
        37.25068563964841,
      ],
      [
        56.78546586587148,
        37.240385957031215,
      ],
      [
        56.756057020946706,
        37.06666464355465,
      ],
      [
        56.69792544872601,
        37.172408051757785,
      ],
      [
        56.66958193127207,
        37.13189596679684,
      ],
      [
        56.65294376408293,
        37.15730185058591,
      ],
      [
        56.6412169905048,
        37.11610312011715,
      ],
      [
        56.586598648109344,
        37.14701449256541,
      ],
      [
        56.52782457054817,
        37.05569064002637,
      ],
      [
        56.54755254318274,
        36.970546597057606,
      ],
      [
        56.56613292140973,
        36.96642672401074,
      ],
      [
        56.597206128314156,
        36.80300509315135,
      ],
      [
        56.56992370992141,
        36.801631802135724,
      ],
      [
        56.522511430018994,
        36.65194308143261,
      ],
      [
        56.49935258503647,
        36.678722256237286,
      ],
      [
        56.51795671408189,
        36.6134909329951,
      ],
      [
        56.497073898407486,
        36.537959927135724,
      ],
      [
        56.47313938794787,
        36.53521334510448,
      ],
      [
        56.47351941922054,
        36.42329012733104,
      ],
      [
        56.41787771634558,
        36.27471974848364,
      ],
      [
        56.39998583363332,
        36.124344382272696,
      ],
      [
        56.33710700232799,
        36.08795217035864,
      ],
      [
        56.34053944309206,
        36.06048635004613,
      ],
      [
        56.37332268742483,
        36.05087331293677,
      ],
      [
        56.37294164953576,
        35.869598898874266,
      ],
      [
        56.38818018113828,
        35.83732656000708,
      ],
      [
        56.3942738800957,
        35.86067250727272,
      ],
      [
        56.40683904205926,
        35.80093434809302,
      ],
      [
        56.39122715301173,
        35.734329733835196,
      ],
      [
        56.44717169836726,
        35.68557790278051,
      ],
      [
        56.477962991470704,
        35.60661366938207,
      ],
      [
        56.43157642502338,
        35.51597646235082,
      ],
      [
        56.45477681750981,
        35.42739919184302,
      ],
      [
        56.43043505519493,
        35.4548650121555,
      ],
      [
        56.383990195096416,
        35.41847280024145,
      ],
      [
        56.39541633964472,
        35.51872304438209,
      ],
      [
        56.33100411981341,
        35.46447804926489,
      ],
      [
        56.26036834008289,
        35.50155690668675,
      ],
      [
        56.22787009505968,
        35.316162619577405,
      ],
      [
        56.178879289262575,
        35.36079457758519,
      ],
      [
        56.154360314753085,
        35.30380300043677,
      ],
      [
        56.11218159084219,
        35.28251698969457,
      ],
      [
        56.093377926574234,
        35.33607533930396,
      ],
      [
        56.03998671401979,
        35.26603749750707,
      ],
      [
        56.04344594760627,
        35.23033193110083,
      ],
      [
        55.95841244202673,
        35.14862111567115,
      ],
      [
        55.919488394751134,
        35.204239401803946,
      ],
      [
        55.8951891428014,
        35.20286611078832,
      ],
      [
        55.80170692069479,
        35.28251698969457,
      ],
      [
        55.795518318175624,
        35.32852223871801,
      ],
      [
        55.745586617135395,
        35.34225514887426,
      ],
      [
        55.73435281682367,
        35.30517629145239,
      ],
      [
        55.69248802154492,
        35.33744863031958,
      ],
      [
        55.66649369171784,
        35.32440236567114,
      ],
      [
        55.63271396478377,
        35.3820805883274,
      ],
      [
        55.595016998246216,
        35.395126852975835,
      ],
      [
        55.57596036130426,
        35.37109426020239,
      ],
      [
        55.57518234201639,
        35.297623190866446,
      ],
      [
        55.527693883347254,
        35.34294179438207,
      ],
      [
        55.514838741008916,
        35.31478932856178,
      ],
      [
        55.48131763759307,
        35.325089011178946,
      ],
      [
        55.47195779603169,
        35.29075673578833,
      ],
      [
        55.42902995203455,
        35.329895529733626,
      ],
      [
        55.329596935991,
        35.25889523487656,
      ],
      [
        55.243775473028634,
        35.362578706556235,
      ],
      [
        55.23004243741084,
        35.44566281300156,
      ],
      [
        55.241940681617386,
        35.50659779023518,
      ],
      [
        55.258806958486296,
        35.49835804414145,
      ],
      [
        55.25213975471032,
        35.55946949433676,
      ],
      [
        55.290166954244505,
        35.57320240449299,
      ],
      [
        55.28036962741417,
        35.72014454316488,
      ],
      [
        55.29721952581759,
        35.74005726289143,
      ],
      [
        55.262336199788834,
        35.79361561250082,
      ],
      [
        55.26272831827576,
        35.829321178907065,
      ],
      [
        55.24664827270286,
        35.81352833222738,
      ],
      [
        55.23330864377444,
        35.84168079804769,
      ],
      [
        55.24809400051198,
        35.886507292053935,
      ],
      [
        55.24181731725116,
        35.95860507037423,
      ],
      [
        55.21905599587232,
        35.99499728228831,
      ],
      [
        55.228083602340114,
        36.036196012757046,
      ],
      [
        55.200601880092975,
        36.1103537276008,
      ],
      [
        55.17560687441505,
        36.137838459613576,
      ],
      [
        55.193679825130104,
        36.191396809222965,
      ],
      [
        55.174427917705515,
        36.27654085219171,
      ],
      [
        55.185823032158545,
        36.31155977309016,
      ],
      [
        55.25373281254372,
        36.34039888441826,
      ],
      [
        55.2592233115291,
        36.3802243238714,
      ],
      [
        55.294501186670104,
        36.38365755141046,
      ],
      [
        55.30899518358653,
        36.41730318129327,
      ],
      [
        55.291366650168435,
        36.43858919203547,
      ],
      [
        55.29685192586027,
        36.51480684340266,
      ],
      [
        55.35127157276447,
        36.60063753187921,
      ],
      [
        55.27020202386882,
        36.614370442035465,
      ],
      [
        55.27059406437905,
        36.76199922621514,
      ],
      [
        55.196822106556326,
        36.80663118422296,
      ],
      [
        55.215277981822034,
        36.87048921644951,
      ],
      [
        55.227838767640584,
        36.85538301527764,
      ],
      [
        55.2417725739772,
        36.93620199707029,
      ],
    ],
  ],
};
